/* ============================================================
   STAG Men's Vitality — Theme JavaScript v1.0
   ============================================================ */

/* ── CART ── */
const StagCart = {
  drawer: null,
  overlay: null,
  countEl: null,
  itemsEl: null,
  subtotalEl: null,
  count: 0,

  init() {
    this.drawer   = document.getElementById('cart-drawer');
    this.overlay  = document.getElementById('cart-overlay');
    this.countEl  = document.getElementById('cart-count');
    this.itemsEl  = document.getElementById('cart-items');
    this.subtotalEl = document.getElementById('cart-subtotal-val');

    document.querySelectorAll('[data-cart-open]').forEach(btn =>
      btn.addEventListener('click', () => this.open())
    );
    document.querySelectorAll('[data-cart-close]').forEach(btn =>
      btn.addEventListener('click', () => this.close())
    );
    if (this.overlay) this.overlay.addEventListener('click', () => this.close());

    document.querySelectorAll('[data-add-to-cart]').forEach(btn =>
      btn.addEventListener('click', e => this.handleATC(e))
    );
  },

  open() {
    if (this.drawer) this.drawer.classList.add('open');
    if (this.overlay) this.overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    this.render();
  },

  close() {
    if (this.drawer) this.drawer.classList.remove('open');
    if (this.overlay) this.overlay.classList.remove('active');
    document.body.style.overflow = '';
  },

  handleATC(e) {
    const btn = e.currentTarget;
    const name  = btn.dataset.productName  || 'STAG Product';
    const price = btn.dataset.productPrice || '0';
    const sub   = btn.dataset.productSub   || '';
    const orig  = btn.textContent;

    this.addItem({ name, price, sub });
    btn.textContent = '✓ Added';
    btn.style.background = '#2a6e2a';
    btn.style.borderColor = '#2a6e2a';
    setTimeout(() => {
      btn.textContent = orig;
      btn.style.background = '';
      btn.style.borderColor = '';
    }, 2000);

    setTimeout(() => this.open(), 400);
  },

  items: [],

  addItem(item) {
    const existing = this.items.find(i => i.name === item.name);
    if (existing) { existing.qty++; }
    else { this.items.push({ ...item, qty: 1 }); }
    this.count++;
    if (this.countEl) this.countEl.textContent = this.count;
  },

  render() {
    if (!this.itemsEl) return;
    if (this.items.length === 0) {
      this.itemsEl.innerHTML = `
        <div style="text-align:center;padding:3rem 0;color:var(--muted);">
          <div style="font-family:var(--font-d);font-size:18px;letter-spacing:.1em;text-transform:uppercase;margin-bottom:.5rem;">Your cart is empty</div>
          <div style="font-size:13px;">Find your stack and start your protocol.</div>
        </div>`;
      if (this.subtotalEl) this.subtotalEl.textContent = '$0.00';
      return;
    }

    let total = 0;
    this.itemsEl.innerHTML = this.items.map(item => {
      const price = parseFloat(item.price.replace('$',''));
      const lineTotal = price * item.qty;
      total += lineTotal;
      return `
        <div class="cart-item">
          <div class="cart-item__img" style="background:var(--void);display:flex;align-items:center;justify-content:center;">
            <svg width="20" height="24" viewBox="0 0 48 60" fill="none">
              <polygon points="24,8 18,2 13,9 16,14 11,12 8,17 13,21 18,17 20,23 24,24" fill="#8c1c1c" opacity=".6"/>
              <polygon points="24,8 30,2 35,9 32,14 37,12 40,17 35,21 30,17 28,23 24,24" fill="#8c1c1c" opacity=".6"/>
              <polygon points="20,24 24,24 28,24 30,40 24,46 18,40" fill="#8c1c1c" opacity=".6"/>
            </svg>
          </div>
          <div>
            <div class="cart-item__name">${item.name}</div>
            <div class="cart-item__sub">${item.sub}</div>
            <div class="cart-item__qty">Qty: ${item.qty}</div>
          </div>
          <div class="cart-item__price">$${lineTotal.toFixed(2)}</div>
        </div>`;
    }).join('');

    if (this.subtotalEl) this.subtotalEl.textContent = `$${total.toFixed(2)}`;
  }
};

/* ── QUIZ ENGINE ── */
const StagQuiz = {
  questions: [
    {
      eyebrow: 'Question 01 of 04',
      text: "What's your primary goal right now?",
      cols: 4,
      options: [
        { icon:'⚡', label:'Energy & Drive', desc:'Feel like yourself again. More fuel, less fog.', value:'energy' },
        { icon:'💪', label:'Performance', desc:'Train harder, recover faster, push limits.', value:'performance' },
        { icon:'🔥', label:'Vitality & Libido', desc:'Reignite confidence and sexual vitality.', value:'vitality' },
        { icon:'🧠', label:'Mind & Focus', desc:'Stay sharp, clear, and mentally strong.', value:'mind' },
      ]
    },
    {
      eyebrow: 'Question 02 of 04',
      text: "What's your biggest complaint lately?",
      cols: 4,
      options: [
        { icon:'😴', label:'Low Energy', desc:'Tired by midday. Coffee stopped working.', value:'fatigue' },
        { icon:'📉', label:'Lost Strength', desc:'Gym performance has dropped. Recovery is slow.', value:'strength' },
        { icon:'🛌', label:'Poor Sleep', desc:'Not sleeping well. Waking up unrefreshed.', value:'sleep' },
        { icon:'🧬', label:'Aging Fast', desc:'Feel older than you should. Want to slow it down.', value:'aging' },
      ]
    },
    {
      eyebrow: 'Question 03 of 04',
      text: 'How old are you?',
      cols: 4,
      options: [
        { icon:'', label:'35–39', desc:'Early decline. Getting ahead of it.', value:'35' },
        { icon:'', label:'40–44', desc:'The shift is real. Time to act.', value:'40' },
        { icon:'', label:'45–54', desc:'Peak reclamation territory.', value:'45' },
        { icon:'', label:'55+', desc:'Experience. Wisdom. Firepower.', value:'55' },
      ]
    },
    {
      eyebrow: 'Question 04 of 04',
      text: 'How would you describe your training?',
      cols: 3,
      options: [
        { icon:'🏋️', label:'Active', desc:'I train regularly — gym, sport, or both.', value:'active' },
        { icon:'🚶', label:'Light', desc:'I move but not intensely. Walks, occasional gym.', value:'light' },
        { icon:'💼', label:'Minimal', desc:'Mostly sedentary. Work takes everything.', value:'minimal' },
      ]
    },
  ],

  stacks: {
    alpha: {
      name:'The Alpha Stack', tagline:'"Everything a man over 40 needs. Nothing he doesn\'t."',
      products:[
        {name:'STAG Drive',role:'Men\'s Vitality — testosterone foundation'},
        {name:'STAG Root',role:'Ashwagandha — cortisol & stress control'},
        {name:'STAG Rest',role:'Sleep Support — overnight recovery'},
      ],
      price:'$89.99', was:'Singles $92.97',
      reason:'Your answers point to a testosterone and energy foundation issue. Drive handles the hormonal base, Root controls the cortisol that\'s killing your T levels, and Rest is where 80% of testosterone production happens.',
      upsell:{name:'STAG D3',sub:'Foundation Add-on',price:'$21.99',desc:'72% of Australian men are Vitamin D deficient — directly impacting testosterone production.'},
      url:'/products/alpha-stack'
    },
    performance: {
      name:'The Performance Stack', tagline:'"Train harder. Recover faster. Stay in the game."',
      products:[
        {name:'STAG Nitro',role:'Nitric Oxide — blood flow & circulation'},
        {name:'STAG Shilajit+',role:'Adaptogen — stamina & sustained energy'},
        {name:'STAG Mag',role:'Magnesium Glycinate — muscle recovery'},
      ],
      price:'$109.99', was:'Singles $108.97',
      reason:'You\'re active and want to perform better. Nitro opens blood vessels for more oxygen, Shilajit+ provides concentrated adaptogen energy, and Mag handles the recovery window most men ignore.',
      upsell:{name:'STAG Beet',sub:'Performance Add-on',price:'$29.99',desc:'Organic Beetroot 1300mg — natural nitric oxide from a completely different pathway to Nitro.'},
      url:'/products/performance-stack'
    },
    vitality: {
      name:'The Vitality Stack', tagline:'"Still in season."',
      products:[
        {name:'STAG Rut',role:'Libido Strips — Cordyceps & Shilajit'},
        {name:'STAG Maca',role:'Triple Maca — hormonal balance & desire'},
        {name:'STAG Drive',role:'Men\'s Vitality — testosterone base'},
      ],
      price:'$109.99', was:'Singles $107.97',
      reason:'Sexual vitality needs three mechanisms: fast-acting libido support (Rut), hormonal balance (Maca), and the testosterone foundation both need to work (Drive).',
      upsell:{name:'STAG Blue',sub:'Premium Add-on',price:'$39.99',desc:'Methylene Blue Drops — mitochondrial energy support for vitality and focus.'},
      url:'/products/vitality-stack'
    },
    longevity: {
      name:'The Longevity Stack', tagline:'"Decline is optional."',
      products:[
        {name:'STAG NAD+',role:'NAD+ Resveratrol Quercetin — cellular energy'},
        {name:'STAG Eternal',role:'NMN 500mg — NAD+ precursor'},
        {name:'STAG Multi',role:'Complete Multivitamin — micronutrient base'},
      ],
      price:'$144.99', was:'Singles $147.97',
      reason:'Your focus on aging calls for the cellular protocol. NMN raises NAD+ more efficiently than direct supplementation. Together with Resveratrol and Quercetin, this is the evidence-backed longevity stack.',
      upsell:{name:'STAG D3',sub:'Longevity Add-on',price:'$21.99',desc:'Vitamin D3 deficiency directly accelerates cellular aging. Essential for any longevity protocol.'},
      url:'/products/longevity-stack'
    },
    mind: {
      name:'The Sharp Mind Stack', tagline:'"Still the sharpest in the room."',
      products:[
        {name:'STAG Think',role:'Cognitive Support — Alpha GPC, Huperzine A'},
        {name:'STAG Mind',role:'Ginkgo + Ginseng — cerebral blood flow'},
        {name:'STAG 5-HTP',role:'Serotonin support — mood & resilience'},
      ],
      price:'$99.99', was:'Singles $99.97',
      reason:'Brain fog needs three angles: nootropic compounds for focus (Think), cerebral blood flow so they reach the brain (Mind), and serotonin for the mood resilience that men overlook (5-HTP).',
      upsell:{name:'STAG Blue',sub:'Premium Add-on',price:'$39.99',desc:'Methylene Blue Drops — mitochondrial function for neurons. The biohacker addition to any cognitive stack.'},
      url:'/products/sharp-mind-stack'
    },
  },

  currentQ: 0,
  answers: [],

  getStack(answers) {
    const [goal, complaint, age, training] = answers;
    if (goal === 'mind') return 'mind';
    if (goal === 'vitality') return 'vitality';
    if (complaint === 'aging' || (age === '55' && goal === 'energy')) return 'longevity';
    if (goal === 'performance' || (training === 'active' && complaint === 'strength')) return 'performance';
    return 'alpha';
  },

  init() {
    const startBtn = document.getElementById('quiz-start-btn');
    const retakeBtn = document.getElementById('quiz-retake');
    if (startBtn) startBtn.addEventListener('click', () => this.start());
    if (retakeBtn) retakeBtn.addEventListener('click', () => this.reset());
  },

  start() {
    document.getElementById('quiz-intro')?.classList.add('hide');
    document.getElementById('quiz-active')?.classList.add('show');
    this.renderQuestion(0);
  },

  renderQuestion(index) {
    const q = this.questions[index];
    const eyebrow = document.getElementById('quiz-eyebrow');
    const qText   = document.getElementById('quiz-q-text');
    const opts    = document.getElementById('quiz-options');
    const progress = document.getElementById('quiz-progress');
    const progLabel = document.getElementById('quiz-progress-label');

    if (eyebrow) eyebrow.textContent = q.eyebrow;
    if (qText) qText.textContent = q.text;
    if (opts) {
      opts.className = `quiz__options${q.cols === 3 ? ' cols-3' : ''}`;
      opts.innerHTML = '';
      q.options.forEach(opt => {
        const btn = document.createElement('button');
        btn.className = 'quiz__option';
        btn.innerHTML = `
          ${opt.icon ? `<div class="quiz__option-icon">${opt.icon}</div>` : ''}
          <div class="quiz__option-label">${opt.label}</div>
          <div class="quiz__option-desc">${opt.desc}</div>`;
        btn.addEventListener('click', () => this.selectOption(opt.value, btn));
        opts.appendChild(btn);
      });
    }

    const pct = ((index) / this.questions.length) * 100 + 25;
    if (progress) progress.style.width = pct + '%';
    if (progLabel) progLabel.textContent = `Question ${index + 1} of ${this.questions.length}`;
  },

  selectOption(value, btnEl) {
    document.querySelectorAll('.quiz__option').forEach(b => b.classList.remove('selected'));
    btnEl.classList.add('selected');

    setTimeout(() => {
      this.answers[this.currentQ] = value;
      if (this.currentQ < this.questions.length - 1) {
        const wrap = document.getElementById('quiz-qwrap');
        if (wrap) wrap.style.opacity = '0';
        setTimeout(() => {
          this.currentQ++;
          if (wrap) wrap.style.opacity = '1';
          this.renderQuestion(this.currentQ);
        }, 220);
      } else {
        const progress = document.getElementById('quiz-progress');
        if (progress) progress.style.width = '100%';
        setTimeout(() => this.showResult(), 300);
      }
    }, 280);
  },

  showResult() {
    document.getElementById('quiz-active')?.classList.remove('show');
    const resultEl = document.getElementById('quiz-result');
    if (resultEl) resultEl.classList.add('show');

    const key   = this.getStack(this.answers);
    const stack = this.stacks[key];
    const up    = stack.upsell;

    const set = (id, val) => { const el = document.getElementById(id); if (el) el.textContent = val; };
    set('qr-name', stack.name);
    set('qr-tagline', stack.tagline);
    set('qr-price', stack.price);
    set('qr-was', stack.was);
    set('qr-reason', stack.reason);
    set('qr-upsell-name', up.name);
    set('qr-upsell-sub', up.sub);
    set('qr-upsell-desc', up.desc);
    set('qr-upsell-price', up.price);

    const prods = document.getElementById('qr-products');
    if (prods) {
      prods.innerHTML = stack.products.map(p =>
        `<div class="quiz__result-prod">
          <div class="quiz__result-dot"></div>
          <span style="color:var(--bone);font-weight:500;">${p.name}</span>
          <span style="color:var(--muted);"> — ${p.role}</span>
        </div>`
      ).join('');
    }

    const atcBtn = document.getElementById('qr-atc');
    if (atcBtn) {
      atcBtn.addEventListener('click', () => {
        StagCart.addItem({name: stack.name, price: stack.price, sub: 'Stack'});
        atcBtn.textContent = '✓ Added to Cart';
        atcBtn.style.background = '#2a6e2a';
        setTimeout(() => { atcBtn.textContent = 'Add Stack to Cart'; atcBtn.style.background = ''; }, 2000);
      });
    }

    document.getElementById('quiz-strip')?.scrollIntoView({behavior:'smooth', block:'center'});
  },

  reset() {
    this.currentQ = 0;
    this.answers = [];
    document.getElementById('quiz-result')?.classList.remove('show');
    document.getElementById('quiz-active')?.classList.remove('show');
    document.getElementById('quiz-intro')?.classList.remove('hide');
    const progress = document.getElementById('quiz-progress');
    if (progress) progress.style.width = '25%';
  }
};

/* ── TABS ── */
function initTabs() {
  document.querySelectorAll('.tab-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const tabId = btn.dataset.tab;
      btn.closest('.tabs-section, [data-tabs]').querySelectorAll('.tab-btn').forEach(b => b.classList.remove('active'));
      btn.closest('.tabs-section, [data-tabs]').querySelectorAll('.tab-content').forEach(t => t.classList.remove('active'));
      btn.classList.add('active');
      const target = document.getElementById('tab-' + tabId);
      if (target) target.classList.add('active');
    });
  });
}

/* ── PURCHASE TOGGLE ── */
function initPurchaseToggle() {
  document.querySelectorAll('.purchase-toggle').forEach(toggle => {
    const otpBtn = toggle.querySelector('#otp-btn') || toggle.querySelector('[data-otp]');
    const subBtn = toggle.querySelector('#sub-btn') || toggle.querySelector('[data-sub]');
    if (!otpBtn || !subBtn) return;

    const priceEl = document.getElementById('price-main') || document.querySelector('.price-main');
    const noteEl  = document.getElementById('price-note');
    const spEl    = document.getElementById('sticky-price') || document.querySelector('.sticky-atc__price');

    const otpPrice = otpBtn.dataset.price || otpBtn.textContent.match(/\$[\d.]+/)?.[0] || '';
    const subPrice = subBtn.dataset.price || subBtn.textContent.match(/\$[\d.]+/)?.[0] || '';

    otpBtn.addEventListener('click', () => {
      otpBtn.classList.add('active'); subBtn.classList.remove('active');
      if (priceEl) priceEl.textContent = otpPrice;
      if (spEl) spEl.textContent = otpPrice;
      if (noteEl) noteEl.textContent = 'Free shipping on orders over $80. Ships 2–3 business days.';
    });

    subBtn.addEventListener('click', () => {
      subBtn.classList.add('active'); otpBtn.classList.remove('active');
      if (priceEl) priceEl.textContent = subPrice;
      if (spEl) spEl.textContent = subPrice;
      if (noteEl) noteEl.textContent = 'Subscribe and save 15%. Cancel anytime. Free shipping always included.';
    });
  });
}

/* ── QTY STEPPER ── */
function initQty() {
  document.querySelectorAll('.qty').forEach(qtyEl => {
    const minus = qtyEl.querySelector('.qty__btn--minus') || qtyEl.querySelector('#qty-minus');
    const plus  = qtyEl.querySelector('.qty__btn--plus')  || qtyEl.querySelector('#qty-plus');
    const num   = qtyEl.querySelector('.qty__num') || qtyEl.querySelector('#qty');
    if (!minus || !plus || !num) return;
    let val = 1;
    minus.addEventListener('click', () => { if (val > 1) { val--; num.value = val; }});
    plus.addEventListener('click',  () => { val++; num.value = val; });
  });
}

/* ── STICKY ATC ── */
function initStickyATC() {
  const hero   = document.querySelector('.product-hero');
  const sticky = document.getElementById('sticky-atc') || document.querySelector('.sticky-atc');
  if (!hero || !sticky) return;

  new IntersectionObserver(([e]) => {
    sticky.classList.toggle('visible', !e.isIntersecting);
  }, { threshold: 0.1 }).observe(hero);

  const stickyBtn = sticky.querySelector('button');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', () => {
      const orig = stickyBtn.textContent;
      stickyBtn.textContent = '✓ Added';
      stickyBtn.style.background = '#2a6e2a';
      setTimeout(() => { stickyBtn.textContent = orig; stickyBtn.style.background = ''; }, 2000);
    });
  }
}

/* ── BOTTLE DRAG ── */
function initBottleDrag() {
  document.querySelectorAll('.bottle-scene').forEach(scene => {
    const bottle = scene.querySelector('.bottle-3d');
    if (!bottle) return;
    let drag = false, sx = 0, sy = 0, ry = -18, rx = 5;
    scene.addEventListener('mousedown', e => { drag = true; sx = e.clientX; sy = e.clientY; });
    window.addEventListener('mousemove', e => {
      if (!drag) return;
      ry += (e.clientX - sx) * 0.4;
      rx -= (e.clientY - sy) * 0.2;
      rx = Math.max(-28, Math.min(28, rx));
      bottle.style.animation = 'none';
      bottle.style.transform = `rotateY(${ry}deg) rotateX(${rx}deg)`;
      sx = e.clientX; sy = e.clientY;
    });
    window.addEventListener('mouseup', () => {
      if (drag) {
        drag = false;
        setTimeout(() => { bottle.style.animation = ''; bottle.style.transform = ''; }, 100);
      }
    });
  });
}

/* ── SCROLL REVEAL ── */
function initScrollReveal() {
  const observer = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('stag-reveal--visible'); });
  }, { threshold: 0.1 });
  document.querySelectorAll('.stack-card,.proof-card,.product-card,.ing-card,.pillar').forEach(el => {
    el.classList.add('stag-reveal');
    observer.observe(el);
  });
}

/* ── MARQUEE PAUSE ON HOVER ── */
function initMarquee() {
  document.querySelectorAll('.marquee').forEach(m => {
    m.addEventListener('mouseenter', () => {
      m.querySelector('.marquee__inner')?.style.setProperty('animation-play-state','paused');
    });
    m.addEventListener('mouseleave', () => {
      m.querySelector('.marquee__inner')?.style.setProperty('animation-play-state','running');
    });
  });
}

/* ── STACK FILTER ── */
function initStackFilter() {
  document.querySelectorAll('.filter-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const filter = btn.dataset.filter;
      document.querySelectorAll('[data-stack-category]').forEach(card => {
        card.style.display = (!filter || filter === 'all' || card.dataset.stackCategory === filter) ? '' : 'none';
      });
    });
  });
}

/* ── ADD TO CART FLASH ── */
function initATCFlash() {
  document.querySelectorAll('.product-card__add, [data-atc-flash]').forEach(btn => {
    btn.addEventListener('click', e => {
      e.stopPropagation();
      const orig = btn.textContent;
      btn.textContent = '✓';
      btn.style.background = '#2a6e2a';
      setTimeout(() => { btn.textContent = orig; btn.style.background = ''; }, 1400);
    });
  });
}

/* ── INIT ALL ── */
document.addEventListener('DOMContentLoaded', () => {
  StagCart.init();
  StagQuiz.init();
  initTabs();
  initPurchaseToggle();
  initQty();
  initStickyATC();
  initBottleDrag();
  initScrollReveal();
  initMarquee();
  initStackFilter();
  initATCFlash();
});
// Count-up animation
document.addEventListener('DOMContentLoaded', function() {
  const counters = document.querySelectorAll('.hero__proof-number');
  counters.forEach(counter => {
    const target = parseInt(counter.innerText);
    const duration = 1500;
    const step = target / (duration / 16);
    let current = 0;
    counter.innerText = '0';
    const timer = setInterval(() => {
      current += step;
      if (current >= target) {
        counter.innerText = target;
        clearInterval(timer);
      } else {
        counter.innerText = Math.floor(current);
      }
    }, 16);
  });
});
// Mega menu
const megaItems = document.querySelectorAll('.site-nav__item--has-mega');
megaItems.forEach(item => {
  const menu = item.querySelector('.mega-menu');
  let closeTimer;

  item.addEventListener('mouseenter', () => {
    clearTimeout(closeTimer);
    menu.style.display = 'block';
  });

  item.addEventListener('mouseleave', () => {
    closeTimer = setTimeout(() => {
      menu.style.display = 'none';
    }, 100);
  });

  menu.addEventListener('mouseenter', () => {
    clearTimeout(closeTimer);
  });

  menu.addEventListener('mouseleave', () => {
    closeTimer = setTimeout(() => {
      menu.style.display = 'none';
    }, 100);
  });
});